exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "od-lazy-element,[od-lazy-element]{display:block}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/postcss-loader!./~/less-loader/lib/loader.js!./javascripts/common/directives/od-lazy-element.less
 ** module id = 795
 ** module chunks = 0 1 3 4 5 6
 **/